var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5034_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5358 12.8115H18.6797C18.8689 13.3295 18.9722 13.8885 18.9722 14.4711V21.4859C18.9722 21.7289 18.93 21.962 18.853 22.1789H21.9215C23.0678 22.1789 24.0002 21.2463 24.0002 20.1001V16.276C24.0003 14.3657 22.4461 12.8115 20.5358 12.8115Z",
    fill: "#829ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02806 14.4711C5.02806 13.8884 5.13142 13.3295 5.3206 12.8115H3.46454C1.55419 12.8115 0 14.3657 0 16.2761V20.1002C0 21.2464 0.932486 22.1789 2.07872 22.1789H5.14726C5.07034 21.962 5.02806 21.7289 5.02806 21.4859V14.4711Z",
    fill: "#829ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1218 11.0068H9.8786C7.96825 11.0068 6.41406 12.561 6.41406 14.4714V21.4862C6.41406 21.8689 6.72428 22.1791 7.10697 22.1791H16.8935C17.2761 22.1791 17.5864 21.8689 17.5864 21.4862V14.4714C17.5864 12.561 16.0322 11.0068 14.1218 11.0068Z",
    fill: "#829ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.82031C9.70259 1.82031 7.8335 3.68941 7.8335 5.9869C7.8335 7.54526 8.69361 8.90628 9.96383 9.62084C10.5663 9.95975 11.2609 10.1534 12 10.1534C12.7392 10.1534 13.4338 9.95975 14.0362 9.62084C15.3065 8.90628 16.1666 7.54521 16.1666 5.9869C16.1666 3.68946 14.2975 1.82031 12 1.82031Z",
    fill: "#829ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68389 5.7041C2.96569 5.7041 1.56787 7.10192 1.56787 8.82012C1.56787 10.5383 2.96569 11.9361 4.68389 11.9361C5.11974 11.9361 5.53477 11.8459 5.91179 11.6836C6.56363 11.4029 7.1011 10.9062 7.43368 10.2839C7.66712 9.84716 7.79992 9.34892 7.79992 8.82012C7.79992 7.10196 6.4021 5.7041 4.68389 5.7041Z",
    fill: "#829ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3162 5.7041C17.598 5.7041 16.2002 7.10192 16.2002 8.82012C16.2002 9.34897 16.333 9.8472 16.5664 10.2839C16.899 10.9062 17.4365 11.403 18.0883 11.6836C18.4653 11.8459 18.8804 11.9361 19.3162 11.9361C21.0344 11.9361 22.4322 10.5383 22.4322 8.82012C22.4322 7.10192 21.0344 5.7041 19.3162 5.7041Z",
    fill: "#829ED1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5034_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.d0d58ef5bad59d4df0dd2340bfe0c78a.svg";
export { ForwardRef as ReactComponent };